import { render, staticRenderFns } from "./EditableItem.vue?vue&type=template&id=ec038b6e&scoped=true"
import script from "./EditableItem.vue?vue&type=script&lang=ts"
export * from "./EditableItem.vue?vue&type=script&lang=ts"
import style0 from "./EditableItem.vue?vue&type=style&index=0&id=ec038b6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec038b6e",
  null
  
)

export default component.exports